import Navigation from "@frog/source/models/Navigation.js"
import * as Preact from "preact"

import encounters from "@frog/source/data/encounters/encounters.js"

import "@frog/source/views/app/screens/OverworldScreen.view.less"
import App from "@frog/source/models/App.js"

export default class OverworldScreen {
    render() {
        return (
            <div class="OverworldScreen">
                <div class="Background"/>
                <div class="String"/>
                <div class="Encounters">
                    {Object.values(encounters).reverse().map((encounter, index) => {
                        let encounterSprite = encounter.sprite_hidden
                        return (
                            <div class="Encounter" slug={encounter.slug} onClick={this.onClickEncounter(encounter)}>
                                <div class="SpriteAgain"><img class="Sprite" src={encounterSprite}/></div>
                                <div class="Label">{encounter.label}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    onClickEncounter(encounter) {
        return (event) => {
            Navigation.go("/game/encounters/" + encounter.slug)
        }
    }
}
